import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-no-internet',
  templateUrl: './nointernet.component.html',
  styleUrls: ['./nointernet.component.scss']
})
export class NoInternetComponent {
  businessRulesAPI: SafeResourceUrl;
  constructor(public sanitizer: DomSanitizer) {
    //Do Nothing
  }

}
